import React from "react";
import PropTypes from "prop-types";
import Carousel from "react-images";
import Modal from "react-modal";
import View from "./View";
import Navigation from "./Navigation";
import NavigationNext from "./NavigationNext";
import NavigationPrev from "./NavigationPrev";
import CloseIcon from "../Icons/CloseIcon";

import styles from "./lightbox.module.scss";

function Lightbox(props) {
  const {isOpen, items, currentIndex, onClose, captionRender} = props;
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      className={styles.root}
      overlayClassName={styles.overlay}
      bodyOpenClassName={styles.body}
    >
      <Carousel
        onClose={onClose}
        captionRender={captionRender}
        hideControlsWhenIdle={false}
        views={items}
        currentIndex={currentIndex}
        styles={{
          footer: (base) => ({
            ...base,
            padding: 0
          })
        }}
        components={{
          FooterCount() {
            return null;
          },
          View,
          Navigation,
          NavigationPrev,
          NavigationNext
        }}
      />
      <button className={styles.close} onClick={onClose}>
        <CloseIcon />
      </button>
    </Modal>
  );
}

Modal.setAppElement(`body`);

Lightbox.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      source: PropTypes.string,
      captionContent: PropTypes.object
    })
  ),
  isOpen: PropTypes.bool,
  currentIndex: PropTypes.number,
  onClose: PropTypes.func,
  captionRender: PropTypes.func
};

export default Lightbox;
